import type { LocationMapTabProps } from "./location-map-tab.type";

import AssetAddButton from "@/modules/asset/asset-add-button";
import LocationAddButton from "@/modules/location/location-add-button";
import LocationMap from "@/modules/location/location-map";

import "./location-map-tab.style.less";

const LocationMapTab = ({ location, loading }: LocationMapTabProps) => {
  return (
    <div className="location-map-tab">
      <div className="location-map-tab-actions">
        <LocationAddButton parentLocation={location} disabled={loading} />
        <AssetAddButton
          ancestors={location?.ancestors}
          defaultCoordinate={location?.coordinate}
          disabled={loading}
        />
      </div>
      <LocationMap
        location={location}
        loading={loading}
        mapKey="location_map_tab"
      />
    </div>
  );
};

export default LocationMapTab;
